module.exports = __webpack_public_path__ + "img/bodycheck3.4a7244cf.jpg";